import { Button, Input, Select, Switch, Tooltip } from "antd";
import {
  DownloadIcon,
  FilterIcon,
  PlusIcon,
  SearchIcon,
  SelectArrow,
  TickIcon,
} from "../../../../../../atoms/CustomIcons";
import React, { useEffect, useState } from "react";
import { getClientManagerFormList } from "../../../../../Company/ducks/actions";
import { useAppDispatch } from "../../../../../../config/hooks";
import { useNavigate } from "react-router-dom";
import { removeServiceListing } from "../../../ducks/actions";

interface FilterProps {
  setFilters: React.Dispatch<
    React.SetStateAction<{
      status: string;
      type: string | undefined;
      frequency: string | undefined;
    }>
  >;
  filters: {
    status: string;
    type: string | undefined;
    frequency: string | undefined;
  };
  archived: boolean;
  isArchived: React.Dispatch<React.SetStateAction<boolean>>;
  companyId: string;
  serviceLineId: string;
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
}

export default function Filters(props: FilterProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    setFilters,
    archived,
    isArchived,
    companyId,
    serviceLineId,
    value,
    setValue,
    filters,
  } = props;
  const [showFilters, setShowFilters] = useState(false);

  const onChange = (checked: boolean) => {
    dispatch(removeServiceListing());
    isArchived(checked);
    if (checked) {
      setFilters((prev) => ({
        ...prev,
        status: "archived",
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        status: "active",
      }));
    }
  };

  const clearFilters = () => {
    setFilters({
      status: "active",
      type: undefined,
      frequency: undefined,
    });
    isArchived(false);
  };

  useEffect(() => {
    dispatch(getClientManagerFormList());
  }, [dispatch]);

  const frequencyList: { value: string; label: string }[] = [
    { value: "one_time", label: "One-time" },
    { value: "weekly", label: "Weekly" },
    { value: "bi_weekly", label: "Bi-weekly" },
    { value: "monthly", label: "Monthly" },
    { value: "quarterly", label: "Quarterly" },
  ];

  const deliveryDropdown: { value: string; label: string }[] = [
    { value: "in_house", label: "In-house" },
    { value: "subcontracted", label: "Subcontracted" },
  ];

  return (
    <div className="filtersWrapper">
      <div
        className="filtersTop"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="filterSearch">
          <Input
            prefix={<SearchIcon />}
            placeholder="Search services"
            allowClear
            value={value}
            onChange={(e) => setValue(e?.target?.value?.toLowerCase())}
          />
        </div>
        <div
          style={{
            display: "flex",
            gap: "8px",
          }}
        >
          <div className="filterDownload">
            <Button
              icon={<FilterIcon />}
              className={`servicesToggleFilter ${
                showFilters && "show_filters"
              } ${archived && "archived"}`}
              onClick={() => setShowFilters(!showFilters)}
              style={{ padding: 0, width: "36px", height: "36px" }}
            ></Button>
          </div>
          <div
            className="filterDownload"
            style={{ display: "flex", gap: "8px" }}
          >
            <Button icon={<DownloadIcon />} className="servicesToggleFilter" />
            <Button
              icon={<PlusIcon />}
              type="primary"
              onClick={() =>
                navigate(
                  `/company-settings/add-service/${serviceLineId}/${companyId}`
                )
              }
            >
              Service
            </Button>
          </div>
        </div>
      </div>

      {showFilters && (
        <div className="filtersBottom" style={{ padding: "8px 0" }}>
          <div className="btmLeft">
            <div className="filterBox">
              <Tooltip title="Type" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  onChange={(value) =>
                    setFilters((prev) => ({ ...prev, type: value }))
                  }
                  value={filters?.type}
                  placeholder="Delivery type"
                  options={deliveryDropdown}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Type" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  onChange={(value) =>
                    setFilters((prev) => ({ ...prev, frequency: value }))
                  }
                  value={filters?.frequency}
                  placeholder="Frequency"
                  options={frequencyList}
                />
              </Tooltip>
            </div>

            <div className="filterBox">
              <div className="switchBox">
                <Switch onChange={onChange} checked={archived} />
                {archived ? "Hide archived" : "Show archived"}
              </div>
            </div>
          </div>

          <div className="btmRight">
            <Button
              className="outlined-btn"
              onClick={clearFilters}
              disabled={!archived && !filters?.type && !filters?.frequency}
            >
              Clear filters
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
